import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';
import { WrapperService } from '~/services/service.wrapper';
import { IAlertDialog } from '~/views/types';

interface ErrorObj {
    description?: string;
    code?: string;
}

interface AlertDialogProps extends IAlertDialog {
    error?: ErrorObj; //
}

export const ForbiddenAlertDialog: FC<AlertDialogProps> = observer(props => {
    const dialogService = useService(DialogService);
    const wrapperService = useService(WrapperService);
    const { forbiddenAlertDialogSrv } = dialogService;
    const { authService } = wrapperService;

    const headerText =
        props.headerText ||
        (props.error?.description ? 'Something went wrong' : '') ||
        forbiddenAlertDialogSrv.headerText;

    const mainText =
        props.mainText ||
        props.error?.description ||
        'You do not have permission to perform this action. Please contact support.' ||
        forbiddenAlertDialogSrv.mainText;

    const showContactInfo =
        props.showContactInfo !== undefined
            ? props.showContactInfo
            : forbiddenAlertDialogSrv.showContactInfo !== undefined
            ? forbiddenAlertDialogSrv.showContactInfo
            : true;

    return (
        <Dialog open={forbiddenAlertDialogSrv.open} className="hr-modal-dialog">
            <div className="modal-dialog modal-dialog-centered alert-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modalContent">
                            <h3>{headerText}</h3>
                            <p>{mainText}</p>
                            <div className="alert-dialog-actions">
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={() => {
                                        forbiddenAlertDialogSrv.handleClose(authService);
                                    }}
                                >
                                    OK
                                </button>
                            </div>
                            {showContactInfo && (
                                <div className="alert-contact-info">
                                    <a href="mailto:customercare@hardrockgames.com">contact support</a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
});
